
/**
 * Mock Redis Service for Frontend
 * 
 * Since browsers cannot connect directly to Redis via TCP, 
 * this service simulates Redis commands using LocalStorage.
 * This interface makes it easy to swap for a real Backend API later.
 */

const DB_PREFIX = 'vot_redis_db:';

class RedisService {
  /**
   * Simulate SET command
   * Saves a value to the database
   */
  async set(key: string, value: any): Promise<boolean> {
    try {
      const stringValue = JSON.stringify(value);
      localStorage.setItem(DB_PREFIX + key, stringValue);
      return true;
    } catch (e) {
      console.error('Redis SET error:', e);
      return false;
    }
  }

  /**
   * Simulate GET command
   * Retrieves a value from the database
   */
  async get<T>(key: string): Promise<T | null> {
    try {
      const item = localStorage.getItem(DB_PREFIX + key);
      if (!item) return null;
      return JSON.parse(item) as T;
    } catch (e) {
      console.error('Redis GET error:', e);
      return null;
    }
  }

  /**
   * Simulate DEL command
   * Removes a key
   */
  async del(key: string): Promise<boolean> {
    try {
      localStorage.removeItem(DB_PREFIX + key);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Simulate FLUSHDB
   * Clears all data associated with this app
   */
  async flushdb(): Promise<void> {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(DB_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  }
}

export const redis = new RedisService();
